__webpack_require__.p = "https://static.parastorage.com/services/wixstores-client-product-widget/b65d4b94e80342102247cc55d567383c804e647e8d3e23750359fdd6/";